
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAxovaNasSyncFolderCreatedDtoFormGroup() {
return new FormGroup({
    contactId: new FormControl<number | undefined>(undefined, [Validators.required]),
    folderCreated: new FormControl<string | undefined>(undefined, [Validators.required]),
})
;
}
      